export function isNotEmptyString(str: string): boolean {
  return str.trim().length > 0;
}
